import { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { Navbar, Nav, Container, Button, Row, Col, Modal } from 'react-bootstrap'
import InputMask from 'react-input-mask'
import ReactGA from 'react-ga4'
import {
  FaCut, FaStar, FaInstagram,
  FaWhatsapp, FaMapMarkerAlt, FaHeart, FaUsers,
  FaSpa, FaQuoteLeft
} from 'react-icons/fa'
import { FaTiktok } from 'react-icons/fa6'
import { GiLipstick, GiNecklace } from 'react-icons/gi'

const SERVICES = [
  {
    icon: <FaCut size={32} />,
    title: 'Corte & Coloração',
    desc: 'Estilos modernos, mechas, ombré hair e balayage com técnicas avançadas de colorimetria.',
  },
  {
    icon: <GiLipstick size={32} />,
    title: 'Maquiagem Profissional',
    desc: 'Make artístico para noivas, formaturas, eventos e dia a dia com produtos de alta performance.',
  },
  {
    icon: <GiNecklace size={32} />,
    title: 'Penteados',
    desc: 'Criações exclusivas para cada ocasião: românticos, modernos, clássicos e sob medida.',
  },
  {
    icon: <FaSpa size={32} />,
    title: 'Tratamentos Estéticos',
    desc: 'Hidratação profunda, limpeza de pele, massagem e hidromassagem para o seu bem-estar.',
  },
]

const REVIEWS = [
  {
    name: 'Ana Paula',
    stars: 5,
    text: 'Atendimento impecável! A equipe do Studio M transformou meu casamento. Me senti linda do início ao fim.',
  },
  {
    name: 'Fernanda Costa',
    stars: 5,
    text: 'Fiz meu dia da noiva aqui e foi perfeito. O ambiente é aconchegante, as profissionais são ótimas e atenciosas.',
  },
  {
    name: 'Juliana Melo',
    stars: 5,
    text: 'Minha turma de madrinhas ficou apaixonada! Organização impecável e resultados incríveis.',
  },
]

const STAR_INDICES = [0, 1, 2, 3, 4]
const SITE_NAME = 'Studio M Cabelo & Pele'
const SITE_PHONE = '+55 14 99633-2992'
const SITE_ADDRESS = 'Rua Francisco Ministro Zani, 4-21'
const SITE_CITY = 'Bauru'
const SITE_REGION = 'SP'
const SITE_URL = 'https://studiombauru.com.br'
const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID
const WHATSAPP_URL = 'https://wa.me/5514996332992'
const INSTAGRAM_URL = 'https://www.instagram.com/studiomhairemake/'
const INSTAGRAM_REEL_URL = 'https://www.instagram.com/reel/DRNVVnfkfZP/?utm_source=ig_embed&utm_campaign=loading'
const TIKTOK_URL = process.env.REACT_APP_TIKTOK_URL || 'https://www.tiktok.com/@studiomhairemake?lang=pt-BR'
const TIKTOK_VIDEO_URL = 'https://www.tiktok.com/@studiomhairemake/video/7508711282737040646?is_from_webapp=1&sender_device=pc&web_id=7624910166710765063'
const GOOGLE_BUSINESS_URL = 'https://share.google/6C1HwKhoq7tNno4V8'
const GOOGLE_MAPS_URL = 'https://www.google.com/maps/search/?api=1&query=Rua+Francisco+Ministro+Zani,+4-21,+Bauru,+SP'
const GOOGLE_MAPS_EMBED_URL = 'https://www.google.com/maps?q=Rua%20Francisco%20Ministro%20Zani%2C%204-21%2C%20Bauru%2C%20SP&output=embed'
const heroBackgroundImage = `url(${process.env.PUBLIC_URL}/images/capa_studiom.png)`
const logoImage = `${process.env.PUBLIC_URL}/images/logo_studiom.webp`
const brideImage = `${process.env.PUBLIC_URL}/images/noiva.png`
const GALLERY_ITEMS = [
  {
    label: 'Penteado e maquiagem',
    src: `${process.env.PUBLIC_URL}/images/galeria_01.jpg`,
    alt: 'Penteado e maquiagem realizados no Studio M em Bauru para evento social',
  },
  {
    label: 'Noiva - Penteado e maquiagem',
    src: `${process.env.PUBLIC_URL}/images/galeria_02.jpg`,
    alt: 'Penteado e maquiagem de noiva realizados no Studio M em Bauru',
  },
  {
    label: 'Coloração / mechas',
    src: `${process.env.PUBLIC_URL}/images/galeria_03.jpg`,
    alt: 'Resultado de coloração e mechas no Studio M em Bauru',
  },
  {
    label: 'Penteado e maquiagem para evento',
    src: `${process.env.PUBLIC_URL}/images/galeria_04.jpg`,
    alt: 'Penteado e maquiagem para evento realizados no Studio M em Bauru',
  },
  {
    label: 'Maquiagem de halloween',
    src: `${process.env.PUBLIC_URL}/images/galeria_05.jpg`,
    alt: 'Maquiagem de halloween realizada no Studio M em Bauru',
  },
  {
    label: 'Noiva - Penteado e maquiagem',
    src: `${process.env.PUBLIC_URL}/images/galeria_06.jpg`,
    alt: 'Penteado e maquiagem de noiva realizados no Studio M em Bauru',
  },
]
const FAQS = [
  {
    question: 'O Studio M atende dia da noiva em Bauru?',
    answer: 'Sim. O Studio M oferece pacote para dia da noiva em Bauru com maquiagem, penteado, preparo de pele, relaxamento e atendimento personalizado para a noiva e madrinhas.',
  },
  {
    question: 'Quais servicos de salao de beleza o Studio M oferece em Bauru?',
    answer: 'Atendemos corte feminino, coloracao, mechas, maquiagem profissional, penteados e tratamentos esteticos.',
  },
  {
    question: 'Como agendar horario no salao de beleza em Bauru?',
    answer: 'O agendamento pode ser feito diretamente pelo WhatsApp do Studio M, com atendimento rapido para orcamentos, horarios e pacotes especiais.',
  },
]

function App() {
  const [scrolled, setScrolled] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)
  const [contactForm, setContactForm] = useState({
    name: '',
    phone: '',
    service: 'Dia da noiva',
    message: '',
  })
  const canonicalUrl = `${SITE_URL}/`
  const seoTitle = 'Studio M | Salao de Beleza em Bauru e Dia da Noiva'
  const seoDescription = 'Studio M Cabelo & Pele e um salao de beleza em Bauru especializado em dia da noiva, maquiagem, penteados, corte feminino, coloracao e tratamentos esteticos.'
  const seoImage = `${SITE_URL}/images/capa_studiom.png`
  const structuredData = JSON.stringify([
    {
      '@context': 'https://schema.org',
      '@type': 'BeautySalon',
      name: SITE_NAME,
      image: seoImage,
      url: canonicalUrl,
      telephone: SITE_PHONE,
      address: {
        '@type': 'PostalAddress',
        streetAddress: SITE_ADDRESS,
        addressLocality: SITE_CITY,
        addressRegion: SITE_REGION,
        addressCountry: 'BR',
      },
      areaServed: [
        {
          '@type': 'City',
          name: 'Bauru',
        },
      ],
      sameAs: [INSTAGRAM_URL, TIKTOK_URL, WHATSAPP_URL, GOOGLE_BUSINESS_URL],
      priceRange: '$$',
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Tuesday',
          opens: '09:00',
          closes: '18:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Wednesday', 'Thursday'],
          opens: '09:00',
          closes: '19:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Friday',
          opens: '08:00',
          closes: '19:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Saturday',
          opens: '08:00',
          closes: '20:00',
        },
      ],
      description: seoDescription,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Dia da noiva em Bauru',
      provider: {
        '@type': 'BeautySalon',
        name: SITE_NAME,
      },
      areaServed: {
        '@type': 'City',
        name: 'Bauru',
      },
      description: 'Pacotes de dia da noiva em Bauru com maquiagem, penteado, preparo de pele, massagem relaxante e atendimento para madrinhas.',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: FAQS.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    },
  ])

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    if (!GA_TRACKING_ID) {
      return undefined
    }

    const currentWindow = document.defaultView

    if (!currentWindow) {
      return undefined
    }

    const trackPageView = () => {
      ReactGA.send({
        hitType: 'pageview',
        page: `${currentWindow.location.pathname}${currentWindow.location.search}${currentWindow.location.hash}`,
        title: document.title,
      })
    }

    trackPageView()
    currentWindow.addEventListener('hashchange', trackPageView)

    return () => currentWindow.removeEventListener('hashchange', trackPageView)
  }, [])

  useEffect(() => {
    const currentWindow = document.defaultView

    if (!currentWindow) {
      return undefined
    }

    const processInstagramEmbeds = () => {
      if (currentWindow.instgrm?.Embeds?.process) {
        currentWindow.instgrm.Embeds.process()
      }
    }

    const existingScript = document.getElementById('instagram-embed-script')

    if (existingScript) {
      processInstagramEmbeds()
      return undefined
    }

    const script = document.createElement('script')
    script.id = 'instagram-embed-script'
    script.async = true
    script.src = 'https://www.instagram.com/embed.js'
    script.onload = processInstagramEmbeds
    document.body.appendChild(script)

    return undefined
  }, [])

  useEffect(() => {
    const existingScript = document.getElementById('tiktok-embed-script')

    if (existingScript) {
      return undefined
    }

    const script = document.createElement('script')
    script.id = 'tiktok-embed-script'
    script.async = true
    script.src = 'https://www.tiktok.com/embed.js'
    document.body.appendChild(script)

    return undefined
  }, [])

  useEffect(() => {
    if (!GA_TRACKING_ID) {
      return undefined
    }

    const currentWindow = document.defaultView

    if (!currentWindow) {
      return undefined
    }

    const trackedDepths = new Set()
    const depthMilestones = [25, 50, 75, 90]

    const handleScrollDepth = () => {
      const documentElement = document.documentElement
      const scrollableHeight = documentElement.scrollHeight - currentWindow.innerHeight

      if (scrollableHeight <= 0) {
        return
      }

      const scrollPercent = Math.round((currentWindow.scrollY / scrollableHeight) * 100)

      depthMilestones.forEach((depth) => {
        if (scrollPercent >= depth && !trackedDepths.has(depth)) {
          trackedDepths.add(depth)
          ReactGA.event('scroll_depth', {
            percent_scrolled: depth,
            page_section: 'landing_page',
          })
        }
      })
    }

    currentWindow.addEventListener('scroll', handleScrollDepth)

    return () => currentWindow.removeEventListener('scroll', handleScrollDepth)
  }, [])

  const openImageModal = (image) => setSelectedImage(image)
  const closeImageModal = () => setSelectedImage(null)
  const formatAnalyticsValue = (value) => {
    if (value === undefined || value === null) {
      return undefined
    }

    return String(value)
      .normalize('NFD')
      .replaceAll(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replaceAll(/[^a-z0-9]+/g, '_')
      .replaceAll(/^_+|_+$/g, '')
  }

  const trackAnalyticsEvent = (eventName, params) => {
    if (!GA_TRACKING_ID) {
      return
    }

    const normalizedParams = Object.fromEntries(
      Object.entries({
        page_name: 'landing_page',
        site_name: SITE_NAME,
        ...params,
      })
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => [key, typeof value === 'string' ? formatAnalyticsValue(value) : value])
    )

    ReactGA.event(eventName, normalizedParams)
  }

  const trackButtonClick = (buttonName, sectionName, destinationName) => {
    trackAnalyticsEvent('button_click', {
      element_name: buttonName,
      element_type: 'button',
      section_name: sectionName,
      destination_name: destinationName,
    })
  }

  const trackContactClick = (channel, sectionName) => {
    trackAnalyticsEvent('contact_click', {
      contact_channel: channel,
      section_name: sectionName,
      destination_name: channel,
    })
  }

  const trackMapInteraction = (interactionName, sectionName) => {
    trackAnalyticsEvent('map_interaction', {
      interaction_name: interactionName,
      section_name: sectionName,
      destination_name: 'google_maps',
    })
  }

  const trackGalleryImageOpen = (image, sectionName) => {
    trackAnalyticsEvent('gallery_image_open', {
      content_name: image.label || image.caption || image.alt,
      content_category: image.label || image.caption || image.alt,
      section_name: sectionName,
    })
  }

  const trackGenerateLead = (serviceType) => {
    trackAnalyticsEvent('generate_lead', {
      lead_channel: 'whatsapp',
      service_type: serviceType,
      section_name: 'contact_section',
      form_name: 'contact_form',
    })
  }

  const handleSectionNavigation = (sectionName) => {
    trackButtonClick(`Ir para ${sectionName}`, 'navigation', `${sectionName.toLowerCase()}_section`)
  }

  const handleImagePreview = (image, location) => {
    trackButtonClick(`Ampliar imagem ${image.label || image.caption || image.alt}`, location, 'image_modal')

    if (location === 'gallery_section') {
      trackGalleryImageOpen(image, location)
    }

    openImageModal(image)
  }

  const handleContactFormChange = (event) => {
    const { name, value } = event.target

    setContactForm((currentForm) => ({
      ...currentForm,
      [name]: value,
    }))
  }

  const handleContactFormSubmit = (event) => {
    event.preventDefault()

    const currentWindow = document.defaultView

    if (!currentWindow) {
      return
    }

    const formattedMessage = [
      'Ola, Studio M. Vim pelo site e quero solicitar atendimento.',
      `Nome: ${contactForm.name}`,
      `Telefone: ${contactForm.phone}`,
      `Servico de interesse: ${contactForm.service}`,
      contactForm.message ? `Mensagem: ${contactForm.message}` : null,
    ]
      .filter(Boolean)
      .join('\n')

    trackGenerateLead(contactForm.service)
    trackContactClick('whatsapp', 'contact_section')
    trackButtonClick('Enviar formulário', 'contact_section', 'whatsapp')
    currentWindow.open(`${WHATSAPP_URL}?text=${encodeURIComponent(formattedMessage)}`, '_blank', 'noopener,noreferrer')
  }

  return (
    <>
      <Helmet>
        <html lang="pt-BR" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />
        <meta
          name="keywords"
          content="salao de beleza em Bauru, dia da noiva em Bauru, maquiagem para noiva, penteado para noiva, cabelo e maquiagem em Bauru, Studio M"
        />
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={seoImage} />
        <meta property="og:image:alt" content="Studio M Cabelo e Pele em Bauru" />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={seoImage} />
        <meta name="twitter:image:alt" content="Studio M Cabelo e Pele em Bauru" />
        <link rel="canonical" href={canonicalUrl} />
        <script type="application/ld+json">{structuredData}</script>
      </Helmet>

      {/* ── NAVBAR ── */}
      <Navbar
        expand="lg"
        variant="dark"
        fixed="top"
        className={`site-navbar ${scrolled ? 'scrolled' : ''}`}
      >
        <Container>
          <Navbar.Brand href="#home" className="brand-logo" onClick={() => handleSectionNavigation('Home')}>
            <img
              src={logoImage}
              alt="Logo Studio M Cabelo e Pele"
              className="brand-logo-image"
            />
            {/* <span className="brand-copy">
              STUDIO M{' '}
              <span className="brand-tagline">Marilene Rodrigues</span>
            </span> */}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="main-navbar" />
          <Navbar.Collapse id="main-navbar">
            <Nav className="ms-auto align-items-lg-center">
              <Nav.Link href="#home" onClick={() => handleSectionNavigation('Home')}>Início</Nav.Link>
              <Nav.Link href="#services" onClick={() => handleSectionNavigation('Serviços')}>Serviços</Nav.Link>
              <Nav.Link href="#bride" onClick={() => handleSectionNavigation('Noivas')}>Noivas</Nav.Link>
              <Nav.Link href="#about" onClick={() => handleSectionNavigation('Sobre')}>Sobre</Nav.Link>
              <Nav.Link href="#gallery" onClick={() => handleSectionNavigation('Galeria')}>Galeria</Nav.Link>
              <Nav.Link href="#contact" onClick={() => handleSectionNavigation('Contato')}>Contato</Nav.Link>
              <Nav.Link href="#faq" onClick={() => handleSectionNavigation('FAQ')}>FAQ</Nav.Link>
              <Button
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-btn ms-lg-3"
                onClick={() => {
                  trackContactClick('whatsapp', 'navbar')
                  trackButtonClick('Agendar', 'navbar', 'whatsapp')
                }}
              >
                <FaWhatsapp className="me-1" /> Agendar
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <main>
        {/* ── HERO ── */}
        <section
          id="home"
          className="hero-section"
          style={{ backgroundImage: heroBackgroundImage }}
        >
          <div className="hero-overlay" />
          <Container className="hero-content text-center text-white">
            <p className="hero-eyebrow">Salão de Beleza em Bauru para Dia da Noiva, Cabelo e Maquiagem</p>
            <h1 className="hero-title">STUDIO M</h1>
            <p className="hero-subtitle">
              O Studio M Cabelo &amp; Pele oferece atendimento personalizado em Bauru para noivas,
              maquiagem profissional, penteados, corte feminino, coloração e estética.<br />
              Mais de 30 anos cuidando de beleza, elegância e bem-estar em momentos especiais.
            </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <Button
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary-custom btn-lg"
                onClick={() => {
                  trackContactClick('whatsapp', 'hero')
                  trackButtonClick('Agendar Horário', 'hero', 'whatsapp')
                }}
              >
                <FaWhatsapp className="me-2" /> Agendar Horário
              </Button>
              <Button
                href="#services"
                variant="outline-light"
                size="lg"
                className="btn-outline-custom"
                onClick={() => trackButtonClick('Ver Serviços', 'hero', 'services_section')}
              >
                Ver Serviços
              </Button>
            </div>
          </Container>
          {/* <a href="#services" className="hero-scroll-hint" aria-label="Ir para a seção de serviços">
            <span />
          </a> */}
        </section>

        {/* ── STATS BAR ── */}
        <section className="stats-bar" aria-label="Indicadores do Studio M em Bauru">
          <Container>
            <Row className="text-center g-0">
              <Col xs={6} md={3} className="stat-item">
                <span className="stat-number">30+</span>
                <span className="stat-label">Anos de experiência</span>
              </Col>
              <Col xs={6} md={3} className="stat-item">
                <span className="stat-number">4.6★</span>
                <span className="stat-label">Avaliação média</span>
              </Col>
              <Col xs={6} md={3} className="stat-item">
                <span className="stat-number">90%+</span>
                <span className="stat-label">Clientes satisfeitas</span>
              </Col>
              <Col xs={6} md={3} className="stat-item">
                <span className="stat-number">∞</span>
                <span className="stat-label">Noivas realizadas</span>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ── SERVIÇOS ── */}
        <section id="services" className="section-light">
          <Container>
            <div className="section-header text-center">
              <p className="section-eyebrow">O que oferecemos</p>
              <h2 className="section-title">Serviços de Salão de Beleza em Bauru</h2>
              <p className="section-subtitle">
                Do atendimento do dia a dia ao dia da noiva em Bauru, o Studio M reúne cabelo,
                maquiagem, penteados e tratamentos estéticos com cuidado individualizado.
              </p>
            </div>
            <Row className="g-6=4 mt-2">
              {SERVICES.map((s) => (
                <Col key={s.title} sm={6} lg={3}>
                  <article className="service-card">
                    <div className="service-icon">{s.icon}</div>
                    <h3 className="service-title">{s.title}</h3>
                    <p className="service-desc">{s.desc}</p>
                  </article>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* ── NOIVAS ── */}
        <section id="bride" className="section-bride">
          <div className="bride-bg-overlay" style={{ backgroundImage: heroBackgroundImage }} />
          <Container className="position-relative">
            <Row className="align-items-center g-5">
              <Col lg={6}>
                <div className="bride-image-wrap">
                  <button
                    type="button"
                    className="image-trigger"
                    onClick={() => handleImagePreview({
                      src: brideImage,
                      alt: 'Noiva produzida no Studio M em Bauru',
                      caption: 'Dia da Noiva no Studio M',
                    }, 'bride_section')}
                    aria-label="Ampliar imagem da noiva"
                  >
                    <img
                      src={brideImage}
                      alt="Noiva produzida no Studio M em Bauru"
                      className="bride-image interactive-image"
                    />
                  </button>
                </div>
              </Col>
              <Col lg={6} className="text-white">
                <p className="section-eyebrow light">Especialidade</p>
                <h2 className="section-title light">Dia da Noiva em Bauru</h2>
                <p className="bride-lead">
                  O Studio M é referência em dia da noiva em Bauru, com ambiente reservado,
                  atendimento acolhedor e uma jornada completa de beleza para noivas que desejam
                  tranquilidade, elegância e resultado impecável.
                </p>
                <ul className="bride-list">
                  <li><FaHeart className="list-icon" /> Maquiagem profissional e penteado para noiva</li>
                  <li><FaHeart className="list-icon" /> Limpeza de pele, hidratação e preparação da pele</li>
                  <li><FaHeart className="list-icon" /> Massagem relaxante e hidromassagem</li>
                  <li><FaUsers className="list-icon" /> Atendimento para madrinhas e familiares</li>
                  <li><FaHeart className="list-icon" /> Planejamento personalizado para cerimônia e fotos</li>
                  <li><FaHeart className="list-icon" /> Espaço exclusivo e confortável no salão</li>
                </ul>
                <Button
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-gold btn-lg mt-2"
                  onClick={() => {
                    trackContactClick('whatsapp', 'noiva')
                    trackButtonClick('Solicitar Orçamento', 'noiva', 'whatsapp')
                  }}
                >
                  <FaWhatsapp className="me-2" /> Solicitar Orçamento
                </Button>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ── SOBRE ── */}
        <section id="about" className="section-light">
          <Container>
            <Row className="align-items-center g-5">
              <Col lg={6}>
                <div className="about-image-wrap">
                  <button
                    type="button"
                    className="image-trigger"
                    onClick={() => handleImagePreview({
                      src: '/images/detalhe_studiom.png',
                      alt: 'Ambiente e detalhes do Studio M, salão de beleza em Bauru',
                      caption: 'Ambiente do Studio M em Bauru',
                    }, 'about_section')}
                    aria-label="Ampliar imagem do ambiente do Studio M"
                  >
                    <img
                      src="/images/detalhe_studiom.png"
                      className="about-img"
                      alt="Ambiente e detalhes do Studio M, salão de beleza em Bauru"
                    />
                  </button>
                </div>
              </Col>
              <Col lg={6}>
                <p className="section-eyebrow">Nossa história</p>
                <h2 className="section-title">Studio M: referência em salão de beleza em Bauru</h2>
                <p className="about-text">
                  Fundado pela profissional <strong>Marilene Rodrigues</strong>, o Studio M nasceu da paixão
                  pela beleza e pela transformação. Localizado em Bauru (SP), o salão se tornou referência
                  por unir técnica, acolhimento e atendimento verdadeiramente personalizado.
                </p>
                <p className="about-text">
                  Com mais de 30 anos de experiência, o Studio M atende mulheres que buscam um salão de beleza
                  em Bauru com foco em resultado, conforto e acompanhamento próximo, inclusive em pacotes para <em>dia da noiva</em>, eventos e produções especiais.
                </p>
                {/* <div className="about-image-wrap mt-4">
                  <div className="img-placeholder small">
                    <FaPaintBrush size={32} />
                    <span>Foto da equipe / Marilene</span>
                  </div>
                </div> */}
              </Col>
            </Row>
          </Container>
        </section>

        <section className="section-social">
          <Container>
            <Row className="align-items-center g-4 g-xl-5">
              <Col lg={5}>
                <div className="section-header social-header">
                  <p className="section-eyebrow">Acompanhe o Studio M</p>
                  <h2 className="section-title">Bastidores, transformações e tendências em tempo real</h2>
                  <p className="section-subtitle social-subtitle">
                    Veja penteados, maquiagens, noivas e produções especiais acontecendo no dia a dia do salão.
                    Se você gosta de acompanhar resultados reais, essa é a melhor forma de ficar perto do Studio M.
                  </p>
                </div>
              </Col>
              <Col lg={7}>
                <Row className="g-4">
                  <Col md={6}>
                    <div className="social-embed-wrap">
                      <blockquote
                        className="instagram-media social-instagram-embed"
                        data-instgrm-permalink={INSTAGRAM_REEL_URL}
                        data-instgrm-version="14"
                      >
                        <a
                          href={INSTAGRAM_REEL_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => trackButtonClick('Embed Instagram', 'social_section', 'instagram_reel')}
                        >
                          Ver esse Reels no Instagram
                        </a>
                      </blockquote>
                    </div>
                    <div className="social-card-content">
                      <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-button social-button-instagram"
                        onClick={() => {
                          trackContactClick('instagram', 'social_section')
                          trackButtonClick('Abrir Instagram', 'social_section', 'instagram')
                        }}
                      >
                        <FaInstagram className="me-2" /> Ver Instagram
                      </a>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="social-embed-wrap">
                      <blockquote
                        className="tiktok-embed social-tiktok-embed"
                        cite={TIKTOK_VIDEO_URL}
                        data-video-id="7508711282737040646"
                      >
                        <section>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            title="@studiomhairemake"
                            href="https://www.tiktok.com/@studiomhairemake?refer=embed"
                          >
                            @studiomhairemake
                          </a>
                        </section>
                      </blockquote>
                    </div>
                    <div className="social-card-content">
                      {TIKTOK_URL ? (
                        <a
                          href={TIKTOK_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="social-button social-button-tiktok"
                          onClick={() => {
                            trackContactClick('tiktok', 'social_section')
                            trackButtonClick('Abrir TikTok', 'social_section', 'tiktok')
                          }}
                        >
                          <FaTiktok className="me-2" /> Ver TikTok
                        </a>
                      ) : (
                        <div className="social-hint-card">
                          <FaTiktok />
                          <span>Se você me passar o link do TikTok, eu ativo o botão e posso trocar esse card por um embed real.</span>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ── GALERIA ── */}
        <section id="gallery" className="section-dark">
          <Container>
            <div className="section-header text-center">
              <p className="section-eyebrow light">Nosso trabalho</p>
              <h2 className="section-title light">Galeria de maquiagem, penteados e noivas</h2>
            </div>
            <Row className="g-3 mt-2">
              {GALLERY_ITEMS.map((item) => (
                <Col key={item.label} xs={6} md={4}>
                  <figure className="gallery-card">
                    <button
                      type="button"
                      className="image-trigger gallery-image-trigger"
                      onClick={() => handleImagePreview({
                        src: item.src,
                        alt: item.alt,
                        caption: item.label,
                        label: item.label,
                      }, 'gallery_section')}
                      aria-label={`Ampliar imagem ${item.label}`}
                    >
                      <img
                        src={item.src}
                        alt={item.alt}
                        className="gallery-image interactive-image"
                      />
                    </button>
                    <figcaption className="gallery-caption">{item.label}</figcaption>
                  </figure>
                </Col>
              ))}
            </Row>
            <div className="text-center mt-4">
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gold"
                onClick={() => {
                  trackContactClick('instagram', 'gallery_section')
                  trackButtonClick('Ver mais no Instagram', 'gallery_section', 'instagram')
                }}
              >
                <FaInstagram className="me-2" /> Ver mais no Instagram
              </a>
            </div>
          </Container>
        </section>

        {/* ── DEPOIMENTOS ── */}
        <section className="section-light">
          <Container>
            <div className="section-header text-center">
              <p className="section-eyebrow">O que dizem sobre nós</p>
              <h2 className="section-title">Depoimentos sobre o Studio M em Bauru</h2>
            </div>
            <Row className="g-4 mt-2">
              {REVIEWS.map((r) => (
                <Col key={r.name} md={4}>
                  <article className="review-card">
                    <FaQuoteLeft className="review-quote" />
                    <p className="review-text">"{r.text}"</p>
                    <div className="review-stars">
                      {STAR_INDICES.map((i) => (
                        <FaStar key={`star-${i}`} color={i < r.stars ? '#C9973D' : '#ddd'} size={16} />
                      ))}
                    </div>
                    <p className="review-name">{r.name}</p>
                  </article>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* ── CONTATO ── */}
        <section id="contact" className="section-contact">
          <Container>
            <div className="section-header text-center text-white">
              <p className="section-eyebrow light">Fale conosco</p>
              <h2 className="section-title light">Contato e agendamento em Bauru</h2>
            </div>
            <Row className="g-4 mt-2 align-items-stretch">
              <Col lg={5}>
                <div className="contact-form-panel">
                  <p className="contact-form-eyebrow">Solicite seu atendimento</p>
                  <h3 className="contact-form-title">Preencha o formulário e continue no WhatsApp</h3>
                  {/* <p className="contact-form-text">
                    Preencha o formulário para agilizar orçamento, disponibilidade e o tipo de atendimento que você procura.
                  </p> */}
                  {/* <div className="contact-form-highlight">
                    <span className="contact-form-highlight-label">WhatsApp direto</span>
                    <a
                      href={WHATSAPP_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-form-highlight-link"
                      onClick={() => trackContactClick('whatsapp', 'contact_section')}
                    >
                      {SITE_PHONE_DISPLAY}
                    </a>
                  </div> */}
                  <form className="contact-form" onSubmit={handleContactFormSubmit}>
                    <label className="contact-form-field">
                      <span>Nome</span>
                      <input
                        type="text"
                        name="name"
                        value={contactForm.name}
                        onChange={handleContactFormChange}
                        placeholder="Seu nome"
                        required
                      />
                    </label>
                    <label className="contact-form-field">
                      <span>WhatsApp</span>
                      <InputMask
                        mask="(99) 99999-9999"
                        maskChar={null}
                        type="tel"
                        name="phone"
                        value={contactForm.phone}
                        onChange={handleContactFormChange}
                        placeholder="(14) 99999-9999"
                        required
                      />
                    </label>
                    <label className="contact-form-field">
                      <span>Serviço desejado</span>
                      <select
                        name="service"
                        value={contactForm.service}
                        onChange={handleContactFormChange}
                      >
                        <option>Dia da noiva</option>
                        <option>Maquiagem</option>
                        <option>Penteado</option>
                        <option>Corte e coloração</option>
                        <option>Tratamentos estéticos</option>
                      </select>
                    </label>
                    <label className="contact-form-field">
                      <span>Mensagem</span>
                      <textarea
                        name="message"
                        value={contactForm.message}
                        onChange={handleContactFormChange}
                        rows="5"
                        placeholder="Conte um pouco sobre o que você precisa, data desejada ou tipo de evento."
                      />
                    </label>
                    <button type="submit" className="contact-form-submit">
                      <FaWhatsapp className="me-2" /> Enviar pelo WhatsApp
                    </button>
                  </form>
                </div>
              </Col>
              <Col lg={7}>
                <div className="contact-info-layout">
                  <div className="contact-social-grid">
                    <div className="contact-card">
                      <div className="contact-icon"><FaInstagram /></div>
                      <h3>Instagram</h3>
                      <p>
                        <a
                          href={INSTAGRAM_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => {
                            trackContactClick('instagram', 'contact_section')
                            trackButtonClick('Contato Instagram', 'contact_section', 'instagram')
                          }}
                        >
                          @studiomhairemake
                        </a>
                      </p>
                    </div>
                    <div className="contact-card">
                      <div className="contact-icon"><FaTiktok /></div>
                      <h3>TikTok</h3>
                      <p>
                        <a
                          href={TIKTOK_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => {
                            trackContactClick('tiktok', 'contact_section')
                            trackButtonClick('Contato TikTok', 'contact_section', 'tiktok')
                          }}
                        >
                          @studiomhairemake
                        </a>
                      </p>
                    </div>
                  </div>
                  <div className="contact-card contact-card-address-highlight contact-card-address-panel">
                    <div className="contact-address-heading">
                      <div className="contact-icon">
                        <FaMapMarkerAlt />
                      </div>
                      <h3>Visite o Studio M</h3>
                    </div>
                    <address className="contact-address">{SITE_ADDRESS}<br />{SITE_CITY} / {SITE_REGION}</address>
                    <p className="contact-address-copy">
                      Veja a localização no mapa e abra a rota direto no Google Maps para navegar até o salão.
                    </p>
                    <div className="contact-map-wrap">
                      <iframe
                        title="Mapa do Studio M em Bauru"
                        src={GOOGLE_MAPS_EMBED_URL}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="contact-map-embed"
                      />
                    </div>
                    <a
                      href={GOOGLE_MAPS_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-map-button"
                      onClick={() => {
                        trackMapInteraction('navigate_click', 'contact_section')
                        trackButtonClick('Navegar endereço', 'contact_section', 'google_maps')
                      }}
                    >
                      <FaMapMarkerAlt className="me-2" /> Navegar até o endereço
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* ── FAQ ── */}
        <section id="faq" className="section-light section-faq">
          <Container>
            <div className="section-header text-center">
              <p className="section-eyebrow">Dúvidas frequentes</p>
              <h2 className="section-title">Perguntas sobre dia da noiva e salão de beleza em Bauru</h2>
              <p className="section-subtitle">
                Esta seção ajuda clientes e mecanismos de busca a entenderem melhor os serviços do Studio M.
              </p>
            </div>
            <Row className="g-4 mt-2">
              {FAQS.map((item) => (
                <Col key={item.question} md={4}>
                  <article className="faq-card">
                    <h3 className="faq-question">{item.question}</h3>
                    <p className="faq-answer">{item.answer}</p>
                  </article>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </main>

      {/* ── FOOTER ── */}
      <footer className="site-footer">
        <Container className="text-center">
          <img
            src={logoImage}
            alt="Logo Studio M Cabelo e Pele"
            className="footer-logo"
          />
          {/* <p className="footer-brand">Studio M <span>Cabelo & Pele</span></p> */}
          <p className="footer-copy">
            © {new Date().getFullYear()} Studio M — Bauru, SP. Salão de beleza com foco em dia da noiva, cabelo e maquiagem.
          </p>
          <div className="footer-social">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              onClick={() => {
                trackContactClick('instagram', 'footer')
                trackButtonClick('Footer Instagram', 'footer', 'instagram')
              }}
            >
              <FaInstagram size={22} />
            </a>
            <a
              href={TIKTOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
              onClick={() => {
                trackContactClick('tiktok', 'footer')
                trackButtonClick('Footer TikTok', 'footer', 'tiktok')
              }}
            >
              <FaTiktok size={22} />
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              onClick={() => {
                trackContactClick('whatsapp', 'footer')
                trackButtonClick('Footer WhatsApp', 'footer', 'whatsapp')
              }}
            >
              <FaWhatsapp size={22} />
            </a>
          </div>
        </Container>
      </footer>

      <Modal
        show={Boolean(selectedImage)}
        onHide={closeImageModal}
        centered
        size="xl"
        className="image-modal"
      >
        <Modal.Body className="image-modal-body">
          {selectedImage && (
            <figure className="image-modal-figure">
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="image-modal-content"
              />
              {selectedImage.caption && (
                <figcaption className="image-modal-caption">{selectedImage.caption}</figcaption>
              )}
            </figure>
          )}
        </Modal.Body>
      </Modal>
    </>
  )
}

export default App